import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "NaNoWriMo day 12 - sloooowly, very slooowly",
  "description": "",
  "published": "2009-11-12T00:00:00.000Z",
  "redirect_from": ["/blog/nanowrimo-day-12-sloooowly-very-slooowly/swizec/828"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Only wrote something like 500 words today, it just did not want to flow. Blah, I'm not winning this thing by a long shot and if it goes on like this I won't even reach my stated goal of 25k words. Fail.`}</p>
    <blockquote>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      